<body>
    <ul>
        <div>
            <input type="file" (change)="onFileSelected($event)" #fileInput>
            <button class="data-save-btn" (click)="salvarNoBanco(jsonData)">Data Save</button>

            <div *ngIf="showProgressBar">
                <progressbar [value]="progressValue" [max]="maxValue">{{ progressValue }} Saved lines</progressbar>
            </div>

            <a #downloadLink style="display: none;"></a>
            <div *ngIf="dataLoaded">
                <p>Total lines {{ jsonData.length }}</p>
                <table>
                    <thead>
                        <tr>
                            <th>
                                Processo
                            </th>
                            <th>
                                Fatura
                            </th>
                            <th>
                                Aeroporto
                            </th>
                            <th>
                                Partida
                            </th>
                            <th>
                                Chegada
                            </th>
                            <th>
                                Hora
                            </th>
                            <th>
                                Rate
                            </th>

                            <th>
                                Frete
                            </th>
                            <th>
                                HAWB
                            </th>
                            <th>
                                Master
                            </th>
                            <th>
                                Volumes
                            </th>
                            <th>
                                Peso
                            </th>
                            <th>
                                Cubagem M³
                            </th>
                            <th>
                                Status
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of jsonData; let i = index">
                            <td>{{ item.processo }}</td>
                            <td>{{ item.fatura }}</td>
                            <td>{{ item.aeroporto }}</td>
                            <td>{{ item.partida }}</td>
                            <td>{{ item.chegada  | date: 'dd-MM-yyyy' }}</td>
                            <td>{{ item.hora }}</td>
                            <td>{{ item.rate }}</td>
                            <td>{{ item.frete }}</td>
                            <td>{{ item.hawb }}</td>
                            <td>{{ item.master }}</td>
                            <td>{{ item.Volumes }}</td>
                            <td>{{ item['Weight Loaded'] }}</td>
                            <td>{{ item.Cubage }}</td>
                            <td>{{ item.status }}</td>                     
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </ul>
</body>
<div *ngIf="isLoading" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>